module.exports = __webpack_public_path__ + "img/fif-success.d6137eab.png";